export function isUsingAlchemyBundler(bundlerUrl) {
    return bundlerUrl.includes('alchemy');
}
